const TABLE_HEADER_CLASSES = [
    '.is-style-table-header-green-stripes',
    '.is-style-table-header-blue-stripes',
    '.is-style-table-header-green',
    '.is-style-table-header-blue'
];
export default class TableHelper {

    setup() {
        if (document.querySelector('.digital-publication-v2')) {
            const tables = document.querySelectorAll('.digital-publication-v2 .wp-block-table');
            this.addHeaderCells(tables);
        }
    }

    addHeaderCells(tables){
        tables.forEach((table) => {
            let twoHeaders = false;
            if (table.querySelectorAll(TABLE_HEADER_CLASSES.join(','))) {
                const rows = table.querySelectorAll('tbody > tr');
                rows.forEach((row, ri) => {
                    const columns = row.querySelectorAll('td');
                    columns.forEach((column, ci) => {
                        if (ri === 0) {
                            if (ci === 0 && !column.innerText.trim()) {
                                twoHeaders = true;
                            } else {
                                this.addHeaderCell(column, 'col');
                            }
                        } else {
                            if (ci === 0 && twoHeaders) {
                                this.addHeaderCell(column, 'row');
                            }
                        }
                    });
                });
            }
        });
    }

    addHeaderCell(td, scope){
        const th = document.createElement('th');
        th.setAttribute('scope', scope);
        th.innerHTML = td.innerHTML.trim();

        Array.from(td.attributes).forEach(attr => {
            th.setAttribute(attr.name, attr.value);
        });

        td.replaceWith(th);
    }
}